import React from 'react'
import AgTechModal from './AgTechModal';
import AgTechTitleDetailHeader from '../../Headers/AgTechTitleDetailHeader';
import { AgTechButton } from '../../Buttons/AgTechButtons';
import { logDev } from '@agtech/core/logging/AgTechLogger';

export type AgTechWarningModalRenderProps = {
    header: string,
    details?: string,
    okayButtonText?: string
}

export type AgTechWarningModalProps = AgTechWarningModalRenderProps & {
    closeModal: () => void
}

let AgTechWarningModal = (props: AgTechWarningModalProps) => {
    logDev('Rendering warning modal', props);

    return (
        <AgTechModal
            classes="agtech-warning-modal"
            closeModal={props.closeModal}
        >
            <div className="agtech-modal-body p-4">
                <AgTechTitleDetailHeader
                    title={props.header}
                    detail={props.details}
                />
            </div>
            <div className="agtech-modal-footer">
                <AgTechButton
                    text={props.okayButtonText ?? "Okay"}
                    action={e => props.closeModal()}
                    classes='mt-auto'
                />
            </div>
        </AgTechModal>
    )
};

export const showWarningModal = (
    props: AgTechWarningModalRenderProps,
    context: {
        showModal: (modalRenderProp: (modalId: string) => React.ReactNode) => string,
        closeModal: (modalId: string) => void
    }
) => new Promise<void>((res, rej) => {
    return context.showModal((modalId) => {
        return (
            <AgTechWarningModal
                {...props}
                closeModal={() => {
                    context.closeModal(modalId);
                    res();
                }}
            />
        );
    })
});

export default AgTechWarningModal;